/**
 * DB-061 — reads the source systems the corpus actually holds from
 * GET /czna-authorities/records/source-systems.
 *
 * <p>The de-enumeration path again (CZNA-312, and CZNA-457 for the neighbouring type
 * filter): the "Zdrojový systém" sidebar filter used to offer a hardcoded
 * `['LOCAL','NKCR','LCNACO','VIAF','OTHER']`. Measured against the local corpus of
 * 1 295 924 records, three of those five matched nothing at all, while ALEPH
 * (1 292 908 records), DERIVED and SEED were not offered — so the value 99.8 % of the
 * corpus carries could not be selected. An offering derived from the data cannot drift
 * that way, and it picks up a new source system the moment an import brings one in.
 *
 * <p>`sourceSystems` is `[]` both while the query is in flight and when it fails. That
 * is deliberate and the caller depends on it: the filter degrades to "Všechny" (plus an
 * already-applied value) rather than rendering a broken control.
 *
 * <p>`type` is the type filter currently IN FORCE on the grid (not the pending sidebar
 * selection), and it scopes the facet the same way it scopes the list. Without it the
 * offering contains values the grid can never show: DERIVED and SEED exist only on
 * `VOCABULARY_*` records, which the default list view excludes, so picking DERIVED
 * would empty the grid — the exact defect this hook was written to remove. It is part
 * of the query key, so changing the applied type refetches the facet.
 */
import { useQuery } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { fetchSourceSystems } from '../api/recordService';
var SOURCE_SYSTEMS_KEY = 'czna-authorities-source-systems';
export var useSourceSystems = function (type) {
    var _a;
    var ky = useOkapiKy();
    var _b = useQuery([SOURCE_SYSTEMS_KEY, type !== null && type !== void 0 ? type : null], function () { return fetchSourceSystems(ky, { type: type }); }), data = _b.data, isLoading = _b.isLoading, isError = _b.isError;
    return {
        sourceSystems: (_a = data === null || data === void 0 ? void 0 : data.sourceSystems) !== null && _a !== void 0 ? _a : [],
        isLoading: isLoading,
        isError: isError,
    };
};
export default useSourceSystems;
